module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/security-seals.46e6f09d.png";